<template>
  <div id="app_slide">
    <el-scrollbar class="app_scrollbar">
      <el-menu mode="vertical"  unique-opened
              :default-active="$route.path"
              text-color="#666"
              active-text-color="#fff"
              :collapse-transition="false"
              :collapse="sliderBarState">
        <sidebar-item :allRoutes='projectRoutes'></sidebar-item>
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SidebarItem from './SidebarItem'
export default {
  components: { SidebarItem },
  name: 'sliderProject',
  data () {
    return {
      activePath: this.$route.path
    }
  },
  computed: {
    ...mapGetters([
      'projectRoutes',
      'sliderBarState'
    ])
  },
  created () {
    // switch (this.$route.path) {
    //   case '/project/createPro': this.activePath = '/project/index'
    //     break
    //   case '/project/modifyProject': this.activePath = '/project/index'
    //     break
    //   case '/project/checkExp': this.activePath = '/project/index'
    //     break
    //   case '/project/createExp': this.activePath = '/project/exp'
    //     break
    //   case '/project/draftExp': this.activePath = '/project/exp'
    //     break
    //   case '/project/modifyExp': this.activePath = '/project/exp'
    //     break
    //   case '/project/multiExp': this.activePath = '/project/exp'
    //     break
    //   case '/project/createMS': this.activePath = '/project/exp'
    //     break
    //   case '/project/modifyMS': this.activePath = '/project/exp'
    //     break
    //   case '/project/createDB': this.activePath = '/project/exp'
    //     break
    //   case '/project/modifyDB': this.activePath = '/project/exp'
    //     break
    //   case '/project/createSam': this.activePath = '/project/sam'
    //     break
    //   case '/project/modifySam': this.activePath = '/project/sam'
    //     break
    //   case '/project/multiSam': this.activePath = '/project/sam'
    //     break
    //   case '/project/createRea': this.activePath = '/project/rea'
    //     break
    //   case '/project/modifyRea': this.activePath = '/project/rea'
    //     break
    // }
  }
}
</script>
<style scope lang="scss">
  @import '../../../styles/variable.scss';
  #app_slide {
    .el-menu:not(.el-menu--collapse) {
      width: 250px;
    }
    height: 100%;
    .displayShow {
      display: none;}
    .app_scrollbar {
      height: 100%;
      .el-menu-item *, .el-submenu__title * {
        font-weight: bold;
      }
    }
    .el-scrollbar__wrap {
      overflow-x: hidden;
      background-color: $sliderColor;
    }
    .menu-wrapper .el-menu-item *, .menu-wrapper .el-submenu__title * {
      font-size: 16px;
    }
    .el-menu {
      background-color: $sliderColor;
      .el-submenu__title:hover {
        background-color: rgba(0, 0, 0, .3);
      }
      .is-active  {
        background-color: $sliderColor;
      }
      .el-menu-item:hover {
        background-color: rgba(0, 0, 0, .3);
      }
    }
    .el-menu--collapse {
      .is-active  {
        background-color: #000;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/firmiana/layout/Sidebar.vue